import {Model} from "ords/dist/model/model";

export class Module extends Model {

    hasModuleUserByUserId(user_id){
        return !!(this.findModuleUserByUserId(user_id));
    }

    findModuleUserByUserId(user_id){
        for(const date of this.module_dates){
            if(date.module_users && date.module_users.length > 0){
                for(const moduleUser of date.module_users){
                    if (moduleUser.user_id === user_id) {
                        return moduleUser;
                    }
                }
            }
        }
        return null
    }

    getUserRegisteredPerDateData(user_id){
        let enrolled = [];
        for(const date of this.module_dates){
            if(date.module_users && date.module_users.length > 0){
                for(const moduleUser of date.module_users){
                    if (moduleUser.user_id === user_id) {
                        enrolled.push({enrolled: true, id: moduleUser.module_date_id});
                    }
                }
            }else {
                enrolled.push({enrolled: false, id: date.id});
            }
        }

        return enrolled;
    }

    getRegistrationTotal() {
        let enrolled = 0;
        let seats = 0;
        for(const date of this.module_dates){
            if(date.module_users_count && date.module_users_count > 0){
                enrolled += date.module_users_count;
            }

            if(parseInt(date.max) > 0){
                seats += parseInt(date.max);
            }
        }
        return `${enrolled}/${seats}`;
    }

    userHasMultipleRegistrations(user_id) {
        let registrationCount = 0;
        for(const date of this.module_dates){
            if(date.module_users && date.module_users.length > 0){
                for(const moduleUser of date.module_users){
                    if (moduleUser.user_id === user_id) {
                        registrationCount ++;
                    }
                }
            }
            if(registrationCount >= 2){
                return true;
            }
        }

        return false;
    }

    getBanner(){
        if(this.file){
            return this.file.image.thumb_path
        }
        else{
            return this.banner
        }
    }

    getTeachers(){
        let teachers = [];

        for (const teacher of this.module_teachers){
            teachers.push(teacher.user.full_name);
        }

        return teachers;
    }

}

export const ModuleModelConfig = {
    name: 'module',
    model: Module,
    relations: [
        {name: 'file', model_name: 'file', type: 'hasOne'},
        {name: 'module_dates', model_name: 'module_dates', type: 'hasMany'},
        {name: 'module_tags', model_name: 'module_tags', type: 'hasMany'},
        {name: 'module_skills', model_name: 'module_skills', type: 'hasMany'},
        {name: 'module_skill_trees', model_name: 'module_skill_trees', type: 'hasMany'},
        {name: 'education_levels', model_name: 'educationLevel', type: 'hasMany'},
        {name: 'module_teachers', model_name: 'module_teachers', type: 'hasMany'},
        {name: 'module_users', model_name: 'module_users', type: 'hasMany'},
        {name: 'rubric_surveys', model_name: 'rubricSurvey', type: 'hasMany'},
        {name: 'las_groups', model_name: 'las_groups', type: 'hasMany'},
        {name: 'las_main_groups', model_name: 'las_main_groups', type: 'hasMany'},
    ]
}
